<template>
  <section>
    <div class="columns is-multiline">
      <div class="column is-8">
        <div class="box">
          <h1 class="has-text-weight-semibold is-size-4">Blocked Content</h1>
          <p class="pb-2">
            By default, sensitive content such as adult content containing nudity,
            violence or suggestive poses is hidden. If you want to enable and view this
            content use the button below. <br />
          </p>

          <div class="field">
            <b-switch
              :disabled="minor"
              :value="user.configuration.mature_content"
              @input="toggleMatureContent"
              type="is-warning"
            >
              Enable +18 years old content viewing
            </b-switch>
          </div>
          <span class="is-italic"
            >Note: If you are under 18 years old this option isn't available.</span
          >
        </div>
        <!-- <div class="box">
          <h1 class="has-text-weight-semibold is-size-4">Blocked Users</h1>
          <p class="pb-2">
            Enter the usernames of the users you want to block.<br />
            To unblock the users, remove them from this list.
          </p>
          <section>

            <b-field label="Blocked username list">
              <b-taginput
                :confirm-keys="[',', 'Tab', 'Enter', ' ']"
                maxtags="500"
                v-model="tags"
                ellipsis
                icon="label"
                placeholder="Add a username"
                aria-close-label="Remove this username"
              >
              </b-taginput>
            </b-field>
            <b-button type="is-success">Save</b-button>
          </section>
        </div> -->
      </div>
    </div>
  </section>
</template>

<script>
import { notificationMixin } from '@/mixins/notificationMixin'
import * as moment from 'moment'
export default {
  mixins: [notificationMixin],
  props: ['user'],
  data () {
    return {
      tags: ['Auckland', 'Wellington', 'Very']
    }
  },
  computed: {
    minor () {
      return moment().diff(this.user.birthday, 'years') < 18
    }
  },
  methods: {
    toggleMatureContent (value) {
      this.$store
        .dispatch('users/configurations/update', { mature_content: value })
        .then((response) => {
          this.actionSuccess(`Mature content parameter set to ${value}`)
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>
